import React from "react";
import thankyouIcon from '../assets/thankyou.svg'

const ThankyouQld = () => {
    return (<>
        <div style={{ margin: '20px auto', maxWidth: '700px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img src={thankyouIcon} style={{ width: '60px', height: '60px' }} />
            <h1 style={{ textAlign: 'center' }}>Please wait for instructions from your trainer.</h1>
        </div>
    </>)
}

export default ThankyouQld
